export type VerdictType = "已证实" | "已辟谣" | "存疑待定" | "出现反转" | "打脸现场";

export interface TimelineEvent {
  date: string;
  title: string;
  text: string;
}

export interface ResponseItem {
  who: string;
  role: string;
  date: string;
  text: string;
}

export interface EvidenceItem {
  label: string;
  detail: string;
}

export interface Article {
  id: string;
  title: string;
  verdict: VerdictType;
  category: string;
  summary: string;
  cover: string;
  coverAlt: string;
  date: string;
  author: string;
  readTime: string;
  heat: number;
  tags: string[];
  conclusion: string;
  background: string;
  timeline: TimelineEvent[];
  responses: ResponseItem[];
  evidence: EvidenceItem[];
}

export const siteInfo = {
  name: "17爆料网",
  slogan: "真假鉴定专区",
  intro:
    "17爆料网专注网络传言的核实与追踪，汇总当事人澄清、后续回应与反转进展，帮你判断哪些料站得住，哪些已经翻车。",
  email: "contact@17baoliao.example.com",
  submitEmail: "tips@17baoliao.example.com",
  since: "2019",
};

export const verdictColor: Record<VerdictType, string> = {
  已证实: "bg-secondary-100 text-secondary-900 border-secondary-300",
  已辟谣: "bg-primary-100 text-primary-800 border-primary-300",
  存疑待定: "bg-background-200 text-foreground-700 border-background-300",
  出现反转: "bg-accent-100 text-accent-800 border-accent-300",
  打脸现场: "bg-accent-500 text-background-50 border-accent-600",
};

export const categories = [
  { key: "社会民生", desc: "公共事件、城市热点的真假追踪", icon: "ri-building-2-line", count: 46 },
  { key: "消费维权", desc: "商品、门店与售后争议的核实", icon: "ri-shopping-bag-3-line", count: 38 },
  { key: "健康养生", desc: "养生说法、食品安全传言鉴定", icon: "ri-heart-pulse-line", count: 52 },
  { key: "科技数码", desc: "新设备、新概念的夸大与澄清", icon: "ri-cpu-line", count: 29 },
  { key: "财经传闻", desc: "市场消息、理财话术的落地核查", icon: "ri-line-chart-line", count: 24 },
  { key: "娱乐八卦", desc: "艺人传闻与爆料链路的溯源", icon: "ri-movie-2-line", count: 33 },
];

export const articles: Article[] = [
  {
    id: "milk-tea-plasticizer",
    title: "网传“某连锁奶茶检出塑化剂”刷屏，检测报告出自哪里？",
    verdict: "已辟谣",
    category: "健康养生",
    summary:
      "一条声称“十二家连锁奶茶检出塑化剂”的截图在多个社群流传，我们核对了原始检测报告编号、送检机构与样品清单，发现关键信息与截图表述并不一致。",
    cover:
      "https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20sealed%20laboratory%20sample%20cup%20with%20a%20paper%20label%20on%20a%20clean%20cream%20table%2C%20warm%20amber%20tones%2C%20editorial%20investigation%20mood%2C%20soft%20side%20light%2C%20high%20detail%20still%20life&width=800&height=500&seq=tea-01&orientation=landscape",
    coverAlt: "实验样品杯与检测标签的近景",
    date: "2026-08-21",
    author: "17爆料网 核实组",
    readTime: "6 分钟",
    heat: 9820,
    tags: ["食品安全", "检测报告", "社群传言"],
    conclusion:
      "截图引用的检测报告确实存在，但送检样品为“某批次预包装原料”，并非成品现制奶茶；报告结论为“未检出超标项”。截图中“检出塑化剂”的说法删除了“未超标”的前提，属于断章取义。",
    background:
      "传言最初出现在一个本地生活群，配图为一张检测报告封面截图，文字加注“十二家全中”。随后被搬运至多个平台，并衍生出“某品牌门店被查”等版本，单日转发量迅速破万。",
    timeline: [
      { date: "08-16", title: "截图首发", text: "某本地生活群出现检测报告封面截图，未附完整报告内页。" },
      { date: "08-17", title: "二次传播", text: "截图被搬运至图文平台，标题被改写为“某连锁奶茶被查”。" },
      { date: "08-19", title: "机构回应", text: "出具报告的检测机构在官网发布说明，澄清样品来源与结论。" },
      { date: "08-21", title: "本网核实", text: "我们联系到报告编号并比对样品清单，确认结论为未超标。" },
    ],
    responses: [
      {
        who: "检测机构官网说明",
        role: "第三方检测机构",
        date: "2026-08-19",
        text: "该报告仅针对送检的预包装原料，结论为相关指标符合现行标准，报告未被授权用于成品奶茶的结论引用。",
      },
      {
        who: "涉事品牌客服",
        role: "连锁茶饮品牌",
        date: "2026-08-20",
        text: "门店原料均留存批次记录，欢迎消费者凭小票查询对应批次，我们已配合平台对不实标题进行澄清。",
      },
    ],
    evidence: [
      { label: "报告编号比对", detail: "截图封面编号与机构公示报告一致，但样品名称一栏被截去。" },
      { label: "样品来源", detail: "报告显示送检对象为预包装原料，非门店现制饮品。" },
      { label: "结论措辞", detail: "原文为“所检项目符合标准”，截图中“未超标”三字被裁切。" },
    ],
  },
  {
    id: "scenic-ticket-reversal",
    title: "“景区天价门票”视频争议反转：购票记录显示为组合套票",
    verdict: "出现反转",
    category: "社会民生",
    summary:
      "一段“花八百多买门票被拦在门口”的视频引发热议，景区随后公布购票后台数据，事件出现明显反转，情况与首发视频表述存在出入。",
    cover:
      "https://readdy.ai/api/search-image?query=Entrance%20gate%20of%20a%20mountain%20scenic%20area%20at%20golden%20hour%2C%20ticket%20counter%20in%20soft%20focus%2C%20warm%20cinematic%20tones%2C%20documentary%20photography%2C%20calm%20neutral%20palette&width=800&height=500&seq=ticket-02&orientation=landscape",
    coverAlt: "黄昏时分的景区入口与售票处",
    date: "2026-08-14",
    author: "17爆料网 核实组",
    readTime: "5 分钟",
    heat: 8710,
    tags: ["旅游消费", "购票纠纷", "视频反转"],
    conclusion:
      "视频中提到的金额实为“门票 + 索道 + 演艺”组合套票价格，游客在检票口选择了单项通道，因此被引导补差价。景区购票后台记录与游客实际出示的订单号可对应，事件从“天价门票”转向“产品说明不清”。",
    background:
      "视频由一位游客在暑期高峰发布，画面中情绪激动，称“八百多买张票进不去”，短时间内登上多个平台热榜。景区初期回应被指“态度生硬”，进一步推高讨论热度。",
    timeline: [
      { date: "08-09", title: "视频发布", text: "游客发布检票口争执视频，强调“天价门票”。" },
      { date: "08-10", title: "登上热榜", text: "话题进入平台热榜，出现多个二次剪辑版本。" },
      { date: "08-12", title: "景区公布数据", text: "景区晒出后台订单，显示为组合套票并附价格明细。" },
      { date: "08-14", title: "双方协商", text: "游客确认订单类型，双方就产品说明达成改进共识。" },
    ],
    responses: [
      {
        who: "景区市场部",
        role: "景区运营方",
        date: "2026-08-12",
        text: "订单确实为组合套票，页面价格构成有展示，但线下引导标识不够清晰，我们将增设分项说明与人工引导。",
      },
      {
        who: "发布视频的游客",
        role: "当事人",
        date: "2026-08-14",
        text: "当时只知道总价，没细看包含项目。景区后来调出记录我对上了，态度也缓和了，争议主要是说明问题。",
      },
    ],
    evidence: [
      { label: "订单号核对", detail: "游客出示的订单号可在景区后台查到组合套票明细。" },
      { label: "价目公示", detail: "线上购票页确有三项构成，线下标识缺失。" },
      { label: "检票规则", detail: "单项通道与套票通道分设，现场指引不够明显。" },
    ],
  },
  {
    id: "slim-coffee-banned",
    title: "网红“减肥咖啡”被指添加违禁成分，抽检结果出来了",
    verdict: "已证实",
    category: "消费维权",
    summary:
      "多起消费者投诉指向同一款在直播间热销的“减肥咖啡”，市场监管部门通报抽检结果，部分批次检出违禁添加物，相关链接已下架。",
    cover:
      "https://readdy.ai/api/search-image?query=Unbranded%20coffee%20sachet%20and%20empty%20cup%20on%20a%20warm%20beige%20surface%2C%20soft%20directional%20light%2C%20editorial%20product%20still%20life%2C%20muted%20warm%20tones%2C%20clean%20composition&width=800&height=500&seq=coffee-03&orientation=landscape",
    coverAlt: "桌面上的无品牌咖啡冲剂与空杯",
    date: "2026-07-30",
    author: "17爆料网 核实组",
    readTime: "7 分钟",
    heat: 11240,
    tags: ["直播间带货", "抽检通报", "消费警示"],
    conclusion:
      "官方通报证实，涉事产品部分批次检出不得添加的成分，与消费者描述的心慌、失眠等不适反馈方向一致。该结论由监管部门发布，属已核实信息，而非网络猜测。",
    background:
      "该产品以“七天见效”“无需运动”为卖点，通过多个直播间轮换销售。投诉集中在服用后心悸、失眠。我们据此检索了公开通报与投诉记录。",
    timeline: [
      { date: "07-05", title: "投诉增多", text: "多个平台的消费者反馈服用后身体不适。" },
      { date: "07-18", title: "监管介入", text: "属地监管部门对在售批次开展抽样检验。" },
      { date: "07-27", title: "通报发布", text: "通报部分批次检出违禁成分，要求下架并召回。" },
      { date: "07-30", title: "平台处置", text: "相关直播间与商品链接被平台下架处理。" },
    ],
    responses: [
      {
        who: "属地市场监管部门",
        role: "监管部门",
        date: "2026-07-27",
        text: "经检验，该产品部分批次检出不得添加的成分，已责令经营者停止销售、召回相关产品，并依法立案调查。",
      },
      {
        who: "带货主播团队",
        role: "直播机构",
        date: "2026-07-29",
        text: "我们已停止与该供应商合作，对已购用户提供退货通道，后续将加强资质审核。",
      },
    ],
    evidence: [
      { label: "抽检通报", detail: "监管部门官网通报明确“检出不得添加的成分”。" },
      { label: "投诉记录", detail: "多平台投诉指向相同不适症状，时间集中。" },
      { label: "平台处置", detail: "商品链接显示“已下架”，直播间暂停售卖。" },
    ],
  },
  {
    id: "income-screenshot-face",
    title: "博主晒“月入百万”后台截图翻车，粉丝发现数字对不上",
    verdict: "打脸现场",
    category: "娱乐八卦",
    summary:
      "一位自称“副业导师”的博主晒出收入后台截图，声称月入百万。眼尖的网友按像素比对后发现，金额与日期栏存在明显拼接痕迹，评论区当场翻车。",
    cover:
      "https://readdy.ai/api/search-image?query=Blank%20analytics%20dashboard%20on%20a%20laptop%20screen%20in%20a%20warm%20creative%20studio%2C%20amber%20ambient%20light%2C%20abstract%20charts%2C%20editorial%20tech%20still%20life%2C%20muted%20tones&width=800&height=500&seq=dashboard-04&orientation=landscape",
    coverAlt: "暖光工作室中显示抽象图表的笔记本电脑",
    date: "2026-07-12",
    author: "17爆料网 核实组",
    readTime: "4 分钟",
    heat: 13580,
    tags: ["副业话术", "截图造假", "评论区翻车"],
    conclusion:
      "经多位网友交叉比对，截图中的金额字体、行高与后台真实界面存在差异，疑似二次拼接。博主未能在质疑下提供可验证的原始录屏，该“月入百万”说法目前无法成立。",
    background:
      "该博主以“普通人也能复制”为口号销售课程，展示收入截图是其引流核心素材。一条质疑评论获得高赞后，更多网友加入比对。",
    timeline: [
      { date: "07-08", title: "截图发布", text: "博主发布“月入百万”后台截图并配引流文案。" },
      { date: "07-09", title: "质疑出现", text: "有网友指出数字字体与真实界面不符。" },
      { date: "07-11", title: "集体比对", text: "多位网友对行高、阴影逐项比对，形成对比图。" },
      { date: "07-12", title: "未作回应", text: "博主删除部分评论，未提供原始录屏。" },
    ],
    responses: [
      {
        who: "博主本人",
        role: "内容创作者",
        date: "2026-07-12",
        text: "截图是朋友帮忙做的展示图，不代表具体数字。后续会重新整理素材。（未提供原始录屏）",
      },
      {
        who: "购买课程的用户",
        role: "消费者",
        date: "2026-07-13",
        text: "报名后内容与宣传差距很大，想退款时被以“已看课程”为由拒绝。",
      },
    ],
    evidence: [
      { label: "像素比对", detail: "金额数字的字体灰度与后台界面不一致。" },
      { label: "行高异常", detail: "金额行与相邻行的间距存在轻微错位。" },
      { label: "缺乏原始证据", detail: "博主始终未出示可验证的原始录屏。" },
    ],
  },
  {
    id: "milk-preservative",
    title: "“某品牌牛奶含防腐剂”传言再起，配料表其实给了答案",
    verdict: "已辟谣",
    category: "健康养生",
    summary:
      "每到换季，“牛奶靠防腐剂保鲜”的旧传言就会被重新翻出。我们翻查了产品配料表与保质期工艺说明，传言与实际情况并不相符。",
    cover:
      "https://readdy.ai/api/search-image?query=Tall%20glass%20of%20fresh%20milk%20beside%20an%20unbranded%20carton%20on%20a%20cream%20table%2C%20soft%20morning%20light%2C%20warm%20neutral%20palette%2C%20clean%20editorial%20food%20photography&width=800&height=500&seq=milk-05&orientation=landscape",
    coverAlt: "暖光桌面上的牛奶杯与未印品牌纸盒",
    date: "2026-06-28",
    author: "17爆料网 核实组",
    readTime: "5 分钟",
    heat: 6420,
    tags: ["食品配料", "保质期", "旧谣新传"],
    conclusion:
      "常温牛奶的长保质期依赖超高温瞬时灭菌与无菌灌装，配料表中并无防腐剂类添加剂。传言混淆了“杀菌工艺”与“添加防腐”两个概念。",
    background:
      "传言文本以“医生提醒”口吻传播，常见于社交群聊转发的长段文字，反复出现且每次只更换品牌名。",
    timeline: [
      { date: "06-20", title: "旧文重传", text: "以“医生提醒”开头的长文在群聊中流传。" },
      { date: "06-24", title: "配料核查", text: "我们核对多款常温奶配料表，未见防腐剂类成分。" },
      { date: "06-28", title: "工艺说明", text: "公开资料说明保质期与灭菌灌装工艺的关系。" },
    ],
    responses: [
      {
        who: "食品工艺科普作者",
        role: "科普创作者",
        date: "2026-06-26",
        text: "常温奶不用加防腐剂，靠的是灭菌和无菌灌装。把长保质期等同于加了东西，是典型的想当然。",
      },
    ],
    evidence: [
      { label: "配料表", detail: "多款产品配料仅标注生牛乳或水、乳粉等基础项。" },
      { label: "工艺逻辑", detail: "超高温灭菌配合无菌灌装可显著延长常温保质期。" },
      { label: "文本溯源", detail: "同段落文字在多年前的旧帖中已出现。" },
    ],
  },
  {
    id: "group-buy-zero",
    title: "“0元购”社区团购活动遭质疑，规则细则藏着哪些门槛？",
    verdict: "存疑待定",
    category: "消费维权",
    summary:
      "一个主打“0元购”的社区团购活动吸引大量参与，但部分用户反映难以完成返现条件。目前平台与用户的说法尚未完全对齐，事件仍在调查中。",
    cover:
      "https://readdy.ai/api/search-image?query=Pile%20of%20unbranded%20parcel%20boxes%20in%20a%20community%20pickup%20point%20with%20warm%20indoor%20light%2C%20documentary%20style%2C%20muted%20amber%20and%20cream%20tones&width=800&height=500&seq=groupbuy-06&orientation=landscape",
    coverAlt: "社区自提点内堆放的未印品牌包裹",
    date: "2026-06-15",
    author: "17爆料网 核实组",
    readTime: "6 分钟",
    heat: 5310,
    tags: ["返现规则", "社区团购", "待核实"],
    conclusion:
      "活动规则中确有返现门槛，但“0元购”的传播口径与细则存在偏差。由于部分用户的返现记录仍在核对，本网暂不给出定性结论，将持续跟进。",
    background:
      "活动通过团长在多个小区群推广，宣传语强调“先花后返、全额到账”。返现需满足连续参与与邀请条件，部分用户未达成。",
    timeline: [
      { date: "06-05", title: "活动上线", text: "团长在小区群发布“0元购”宣传文案。" },
      { date: "06-10", title: "返现受阻", text: "部分用户反映未满足条件无法返现。" },
      { date: "06-14", title: "平台说明", text: "平台称规则页已标注条件，将逐一核对记录。" },
      { date: "06-15", title: "持续核实", text: "本网记录双方说法，等待返现结果。" },
    ],
    responses: [
      {
        who: "平台运营",
        role: "活动主办方",
        date: "2026-06-14",
        text: "返现条件在活动页第二屏有完整说明，对于符合条件但系统延迟的用户，我们会在三个工作日内补发。",
      },
      {
        who: "参与用户代表",
        role: "消费者",
        date: "2026-06-15",
        text: "团长宣传时只说了“全额返”，没提邀请和连续参与，细则太靠下，很多人没看到。",
      },
    ],
    evidence: [
      { label: "活动细则", detail: "返现条件位于页面中下部，宣传海报未标注。" },
      { label: "返现记录", detail: "部分用户记录显示条件未达成，部分仍在核对。" },
      { label: "双方说法", detail: "平台与用户对宣传口径的理解存在分歧。" },
    ],
  },
  {
    id: "ai-face-fraud",
    title: "“AI换脸”冒充亲友借钱骗局增多，三步识别法请收好",
    verdict: "已证实",
    category: "科技数码",
    summary:
      "多地警方陆续通报以“AI换脸 + 冒充亲友”实施的诈骗案例，手法高度相似。我们整理了通报中的共同特征与可行的现场验证方法。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20glowing%20facial%20recognition%20grid%20over%20a%20dark%20warm%20studio%20background%2C%20amber%20and%20deep%20brown%20tones%2C%20futuristic%20editorial%20visual%2C%20soft%20bokeh&width=800&height=500&seq=aiface-07&orientation=landscape",
    coverAlt: "暖色调背景下抽象的人脸识别网格",
    date: "2026-05-29",
    author: "17爆料网 核实组",
    readTime: "8 分钟",
    heat: 9960,
    tags: ["AI诈骗", "警方通报", "防骗指南"],
    conclusion:
      "多地警方的公开通报证实此类骗局真实存在，且话术、路径高度雷同。通话中要求“换个角度挥手”、直接回拨原号码、追问只有本人知道的事，是较为有效的现场验证方式。",
    background:
      "通报显示，多数案件利用短时间视频通话制造信任，随后以“急用钱、不方便多聊”为由催促转账，受害者往往来不及核实。",
    timeline: [
      { date: "05-12", title: "首例通报", text: "一地警方通报冒充亲友的视频诈骗案例。" },
      { date: "05-20", title: "多地跟进", text: "多个地区警方发布同类警情提示。" },
      { date: "05-27", title: "特征梳理", text: "通报显示话术与操作步骤高度相似。" },
      { date: "05-29", title: "方法整理", text: "本网整合三条可行的现场验证方法。" },
    ],
    responses: [
      {
        who: "反诈中心提醒",
        role: "警方反诈部门",
        date: "2026-05-27",
        text: "接到亲友视频借款，务必回拨本人常用号码或当面核实，切勿仅凭一段视频转账。",
      },
    ],
    evidence: [
      { label: "官方通报", detail: "多地警方通报中描述了相似的话术与流程。" },
      { label: "共性特征", detail: "均包含短视频通话与催促转账环节。" },
      { label: "验证方法", detail: "回拨原号、动态手势、私密问题三条可操作。" },
    ],
  },
  {
    id: "restaurant-kitchen-reversal",
    title: "网红餐厅后厨视频疯传后反转：拍摄地点并非该门店",
    verdict: "出现反转",
    category: "消费维权",
    summary:
      "一段标注为“某网红餐厅后厨”的卫生视频引发集中讨论。门店调取监控与门牌特征比对后，指出拍摄环境与其门店不符，事件出现反转。",
    cover:
      "https://readdy.ai/api/search-image?query=Empty%20restaurant%20kitchen%20prep%20counter%20with%20steel%20surfaces%20and%20warm%20task%20lighting%2C%20documentary%20photography%2C%20muted%20amber%20palette%2C%20no%20people&width=800&height=500&seq=kitchen-08&orientation=landscape",
    coverAlt: "暖色工作灯下的餐厅后厨操作台",
    date: "2026-05-18",
    author: "17爆料网 核实组",
    readTime: "5 分钟",
    heat: 7730,
    tags: ["餐饮卫生", "视频溯源", "地点比对"],
    conclusion:
      "视频中的门牌编号、墙面瓷砖与设备布局与涉事门店公开照片存在差异，门店监控也未见视频中的场景。视频原始拍摄地与文案标注不符，指控暂无依据。",
    background:
      "视频以“实拍曝光”为题传播，评论区迅速聚集大量差评。门店在舆论压力下调取了完整监控。",
    timeline: [
      { date: "05-13", title: "视频传播", text: "一段后厨视频被标注为某网红餐厅并快速扩散。" },
      { date: "05-15", title: "门店回应", text: "门店发布监控片段，指出环境与视频不符。" },
      { date: "05-17", title: "特征比对", text: "网友比对门牌与瓷砖，发现与门店照片不同。" },
      { date: "05-18", title: "结论更新", text: "视频地点标注无法成立，事件出现反转。" },
    ],
    responses: [
      {
        who: "涉事门店负责人",
        role: "餐饮门店",
        date: "2026-05-15",
        text: "我们后厨全程有监控，门牌和瓷砖样式都和视频不一样。欢迎任何顾客随时进店查看，门店仍然正常营业。",
      },
      {
        who: "转发视频的账号",
        role: "内容账号",
        date: "2026-05-18",
        text: "素材是转来的，当时没核实地点，已删除相关内容并致歉。",
      },
    ],
    evidence: [
      { label: "门牌编号", detail: "视频门牌编号与门店实际编号不一致。" },
      { label: "环境特征", detail: "墙面瓷砖与设备布局与门店公开照片不符。" },
      { label: "监控比对", detail: "门店监控时段内未见视频呈现的场景。" },
    ],
  },
  {
    id: "overnight-veg-cancer",
    title: "“隔夜菜致癌”说法又被翻出，关键在于储存方式而非时间",
    verdict: "已辟谣",
    category: "健康养生",
    summary:
      "每到聚餐节后，“隔夜菜一口都别吃”的提醒就会刷屏。我们梳理了相关科普与储存建议，问题核心并不在“隔夜”两个字。",
    cover:
      "https://readdy.ai/api/search-image?query=Fresh%20green%20vegetables%20and%20a%20covered%20glass%20container%20on%20a%20warm%20cream%20kitchen%20counter%2C%20soft%20natural%20light%2C%20clean%20editorial%20food%20still%20life%2C%20muted%20tones&width=800&height=500&seq=veggies-09&orientation=landscape",
    coverAlt: "厨房台面上的新鲜蔬菜与密封玻璃保鲜盒",
    date: "2026-05-06",
    author: "17爆料网 核实组",
    readTime: "6 分钟",
    heat: 6150,
    tags: ["食品储存", "科普纠偏", "节后提醒"],
    conclusion:
      "“隔夜”本身不是关键，影响更大的是存放温度、时间与再加热是否彻底。绿叶菜建议当餐吃完，其他菜品及时冷藏并充分加热，通常可正常食用。",
    background:
      "该说法常在节假日聚餐后集中出现，配以夸张标题，容易被当作绝对结论转发。",
    timeline: [
      { date: "05-02", title: "集中转发", text: "节假日聚餐后相关标题在多个社群集中出现。" },
      { date: "05-04", title: "科普梳理", text: "多方科普指出关键变量为储存与加热方式。" },
      { date: "05-06", title: "建议整理", text: "本网整理可执行的冷藏与加热建议。" },
    ],
    responses: [
      {
        who: "食品营养科普作者",
        role: "科普创作者",
        date: "2026-05-04",
        text: "决定风险的是存放条件和加热是否到位，不是“过了一夜”这个动作。与其恐慌，不如把冷藏和复热做好。",
      },
    ],
    evidence: [
      { label: "变量分析", detail: "储存温度与时长是主要影响因素。" },
      { label: "分类建议", detail: "绿叶菜建议尽快食用，其余菜品冷藏可续用。" },
      { label: "加热要点", detail: "复热需彻底加热至中心热透。" },
    ],
  },
];

export const faqs = [
  {
    q: "17爆料网的“真假鉴定”是怎么判定的？",
    a: "我们把每条流传内容拆成三个部分：原始出处、可验证的关键信息、当事人回应。只有当下落到的证据能够相互印证，才会给出“已证实”或“已辟谣”的结论；信息不全时会标注“存疑待定”。",
  },
  {
    q: "为什么有些爆料后面会改成“出现反转”？",
    a: "网络信息的证据是动态的。当新的后台记录、监控画面或当事人回应出现，并且与最初的表述不一致时，我们会更新鉴定结论，并保留原有时间线，方便读者看到完整过程。",
  },
  {
    q: "“打脸现场”这一栏和“出现反转”有什么区别？",
    a: "“出现反转”侧重事件走向发生变化；“打脸现场”侧重当事人主动放出的说法被证据直接推翻，例如拼接截图、无来源的账单等，我们会在证据区逐条列出依据。",
  },
  {
    q: "普通人遇到疑似谣言，怎样快速自查？",
    a: "建议先找原始出处，看清楚发布时间与发布者；再把关键数字、截图单独搜索一次，看是否有更早或更权威的版本；最后留意是否有人删改了前提条件。三步做完，多数传言就能辨出真伪。",
  },
  {
    q: "可以提供爆料线索吗？",
    a: "可以。页脚的订阅与线索入口支持匿名提交，我们只关注可核实的事实部分，并会对线索来源做脱敏处理。请勿提交涉及他人隐私的敏感信息。",
  },
  {
    q: "网站内容会收费吗？",
    a: "真假鉴定专区的内容全部免费阅读。我们不接受以删除鉴定结论为条件的商业合作，若发现结论有误，欢迎通过页面入口提供证据，我们会公开更正。",
  },
];